export default {"src":"/_next/static/media/clipboardWithCross_24.ec6d908a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};